// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36s0z","buttons":"styles_buttons__3AntT"};